import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isPwaStandaloneDisplay } from '@/core/presentation/utils/pwa-display-mode';
import { ROUTES } from '@/app/routes';

const LANDING_PATHS = ['/', '/home'];

/**
 * Quando o app é aberto como PWA (standalone), redireciona da landing para /login.
 */
export function PwaLandingRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isPwaStandaloneDisplay()) return;

    const isLanding = LANDING_PATHS.includes(location.pathname);
    if (isLanding) {
      navigate(ROUTES.LOGIN, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}
